import { render } from "./App.vue?vue&type=template&id=7eb32c3c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7eb32c3c&lang=stylus"
script.render = render

export default script